// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ChangeRequestsDependencyModalQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  kind: Types.ChangeRequestDependency;
}>;


export type ChangeRequestsDependencyModalQuery = { __typename?: 'Query', changeRequest: { __typename?: 'ChangeRequest', id: string, name: string, blocking: Array<{ __typename?: 'ChangeRequest', id: string, name: string, groups: Array<{ __typename?: 'ChangeRequestGroup', id: string }>, blueprintUrl: { __typename?: 'Url', path: string } }>, blockers: Array<{ __typename?: 'ChangeRequest', id: string, name: string, groups: Array<{ __typename?: 'ChangeRequestGroup', id: string }>, blueprintUrl: { __typename?: 'Url', path: string } }>, linkedTo: Array<{ __typename?: 'ChangeRequest', id: string, name: string, groups: Array<{ __typename?: 'ChangeRequestGroup', id: string }>, blueprintUrl: { __typename?: 'Url', path: string } }>, groups: Array<{ __typename?: 'ChangeRequestGroup', id: string, name: string, changeRequests: Array<{ __typename?: 'ChangeRequest', id: string, name: string, groups: Array<{ __typename?: 'ChangeRequestGroup', id: string }>, blueprintUrl: { __typename?: 'Url', path: string } }> }> }, availableDependencyChangeRequests: Array<{ __typename?: 'ChangeRequest', id: string, name: string, groups: Array<{ __typename?: 'ChangeRequestGroup', id: string }>, blueprintUrl: { __typename?: 'Url', path: string } }> };

export type ChangeRequestGroupsForModalQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ChangeRequestGroupsForModalQuery = { __typename?: 'Query', changeRequestGroups: Array<{ __typename?: 'ChangeRequestGroup', id: string, name: string, changeRequests: Array<{ __typename?: 'ChangeRequest', id: string, name: string, groups: Array<{ __typename?: 'ChangeRequestGroup', id: string }>, blueprintUrl: { __typename?: 'Url', path: string } }> }> };

export type SaveChangeRequestDependencyBlockingMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  blocking?: Types.InputMaybe<Array<Types.SaveChangeRequestDependencyInput> | Types.SaveChangeRequestDependencyInput>;
}>;


export type SaveChangeRequestDependencyBlockingMutation = { __typename?: 'Mutation', saveChangeRequest: { __typename?: 'SaveChangeRequestResult', changeRequest: { __typename?: 'ChangeRequest', id: string, name: string, blocking: Array<{ __typename?: 'ChangeRequest', id: string, name: string, groups: Array<{ __typename?: 'ChangeRequestGroup', id: string }>, blueprintUrl: { __typename?: 'Url', path: string } }>, blockers: Array<{ __typename?: 'ChangeRequest', id: string, name: string, groups: Array<{ __typename?: 'ChangeRequestGroup', id: string }>, blueprintUrl: { __typename?: 'Url', path: string } }>, linkedTo: Array<{ __typename?: 'ChangeRequest', id: string, name: string, groups: Array<{ __typename?: 'ChangeRequestGroup', id: string }>, blueprintUrl: { __typename?: 'Url', path: string } }>, groups: Array<{ __typename?: 'ChangeRequestGroup', id: string, name: string, changeRequests: Array<{ __typename?: 'ChangeRequest', id: string, name: string, groups: Array<{ __typename?: 'ChangeRequestGroup', id: string }>, blueprintUrl: { __typename?: 'Url', path: string } }> }> } } };

export type SaveChangeRequestDependencyBlockersMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  blockers?: Types.InputMaybe<Array<Types.SaveChangeRequestDependencyInput> | Types.SaveChangeRequestDependencyInput>;
}>;


export type SaveChangeRequestDependencyBlockersMutation = { __typename?: 'Mutation', saveChangeRequest: { __typename?: 'SaveChangeRequestResult', changeRequest: { __typename?: 'ChangeRequest', id: string, name: string, blocking: Array<{ __typename?: 'ChangeRequest', id: string, name: string, groups: Array<{ __typename?: 'ChangeRequestGroup', id: string }>, blueprintUrl: { __typename?: 'Url', path: string } }>, blockers: Array<{ __typename?: 'ChangeRequest', id: string, name: string, groups: Array<{ __typename?: 'ChangeRequestGroup', id: string }>, blueprintUrl: { __typename?: 'Url', path: string } }>, linkedTo: Array<{ __typename?: 'ChangeRequest', id: string, name: string, groups: Array<{ __typename?: 'ChangeRequestGroup', id: string }>, blueprintUrl: { __typename?: 'Url', path: string } }>, groups: Array<{ __typename?: 'ChangeRequestGroup', id: string, name: string, changeRequests: Array<{ __typename?: 'ChangeRequest', id: string, name: string, groups: Array<{ __typename?: 'ChangeRequestGroup', id: string }>, blueprintUrl: { __typename?: 'Url', path: string } }> }> } } };

export type SaveChangeRequestRelatedToMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  linkedTo?: Types.InputMaybe<Array<Types.SaveChangeRequestLinkInput> | Types.SaveChangeRequestLinkInput>;
  groups: Array<Types.SaveChangeRequestGroupInput> | Types.SaveChangeRequestGroupInput;
}>;


export type SaveChangeRequestRelatedToMutation = { __typename?: 'Mutation', saveChangeRequest: { __typename?: 'SaveChangeRequestResult', changeRequest: { __typename?: 'ChangeRequest', id: string, name: string, blocking: Array<{ __typename?: 'ChangeRequest', id: string, name: string, groups: Array<{ __typename?: 'ChangeRequestGroup', id: string }>, blueprintUrl: { __typename?: 'Url', path: string } }>, blockers: Array<{ __typename?: 'ChangeRequest', id: string, name: string, groups: Array<{ __typename?: 'ChangeRequestGroup', id: string }>, blueprintUrl: { __typename?: 'Url', path: string } }>, linkedTo: Array<{ __typename?: 'ChangeRequest', id: string, name: string, groups: Array<{ __typename?: 'ChangeRequestGroup', id: string }>, blueprintUrl: { __typename?: 'Url', path: string } }>, groups: Array<{ __typename?: 'ChangeRequestGroup', id: string, name: string, changeRequests: Array<{ __typename?: 'ChangeRequest', id: string, name: string, groups: Array<{ __typename?: 'ChangeRequestGroup', id: string }>, blueprintUrl: { __typename?: 'Url', path: string } }> }> } }, saveChangeRequestGroups: { __typename?: 'SaveChangeRequestGroupsResult', changeRequestGroups: Array<{ __typename?: 'ChangeRequestGroup', id: string, name: string, changeRequests: Array<{ __typename?: 'ChangeRequest', id: string, name: string, blocking: Array<{ __typename?: 'ChangeRequest', id: string, name: string, groups: Array<{ __typename?: 'ChangeRequestGroup', id: string }>, blueprintUrl: { __typename?: 'Url', path: string } }>, blockers: Array<{ __typename?: 'ChangeRequest', id: string, name: string, groups: Array<{ __typename?: 'ChangeRequestGroup', id: string }>, blueprintUrl: { __typename?: 'Url', path: string } }>, linkedTo: Array<{ __typename?: 'ChangeRequest', id: string, name: string, groups: Array<{ __typename?: 'ChangeRequestGroup', id: string }>, blueprintUrl: { __typename?: 'Url', path: string } }>, groups: Array<{ __typename?: 'ChangeRequestGroup', id: string, name: string, changeRequests: Array<{ __typename?: 'ChangeRequest', id: string, name: string, groups: Array<{ __typename?: 'ChangeRequestGroup', id: string }>, blueprintUrl: { __typename?: 'Url', path: string } }> }> }> }> } };

export type DependencyModalOption_ChangeRequestFragment = { __typename?: 'ChangeRequest', id: string, name: string, groups: Array<{ __typename?: 'ChangeRequestGroup', id: string }>, blueprintUrl: { __typename?: 'Url', path: string } };

export type DependencyModal_ChangeRequestFragment = { __typename?: 'ChangeRequest', id: string, name: string, blocking: Array<{ __typename?: 'ChangeRequest', id: string, name: string, groups: Array<{ __typename?: 'ChangeRequestGroup', id: string }>, blueprintUrl: { __typename?: 'Url', path: string } }>, blockers: Array<{ __typename?: 'ChangeRequest', id: string, name: string, groups: Array<{ __typename?: 'ChangeRequestGroup', id: string }>, blueprintUrl: { __typename?: 'Url', path: string } }>, linkedTo: Array<{ __typename?: 'ChangeRequest', id: string, name: string, groups: Array<{ __typename?: 'ChangeRequestGroup', id: string }>, blueprintUrl: { __typename?: 'Url', path: string } }>, groups: Array<{ __typename?: 'ChangeRequestGroup', id: string, name: string, changeRequests: Array<{ __typename?: 'ChangeRequest', id: string, name: string, groups: Array<{ __typename?: 'ChangeRequestGroup', id: string }>, blueprintUrl: { __typename?: 'Url', path: string } }> }> };

export type DependencyModal_ChangeRequestGroupFragment = { __typename?: 'ChangeRequestGroup', id: string, name: string, changeRequests: Array<{ __typename?: 'ChangeRequest', id: string, name: string, groups: Array<{ __typename?: 'ChangeRequestGroup', id: string }>, blueprintUrl: { __typename?: 'Url', path: string } }> };

export const DependencyModalOption_ChangeRequestFragmentDoc = gql`
    fragment DependencyModalOption_ChangeRequest on ChangeRequest {
  ...Named
  groups {
    id
  }
  blueprintUrl {
    path
  }
}
    ${NamedFragmentDoc}`;
export const DependencyModal_ChangeRequestGroupFragmentDoc = gql`
    fragment DependencyModal_ChangeRequestGroup on ChangeRequestGroup {
  id
  name
  changeRequests {
    ...DependencyModalOption_ChangeRequest
  }
}
    ${DependencyModalOption_ChangeRequestFragmentDoc}`;
export const DependencyModal_ChangeRequestFragmentDoc = gql`
    fragment DependencyModal_ChangeRequest on ChangeRequest {
  ...Named
  blocking {
    ...DependencyModalOption_ChangeRequest
  }
  blockers {
    ...DependencyModalOption_ChangeRequest
  }
  linkedTo {
    ...DependencyModalOption_ChangeRequest
  }
  groups {
    ...DependencyModal_ChangeRequestGroup
  }
}
    ${NamedFragmentDoc}
${DependencyModalOption_ChangeRequestFragmentDoc}
${DependencyModal_ChangeRequestGroupFragmentDoc}`;
export const ChangeRequestsDependencyModalDocument = gql`
    query ChangeRequestsDependencyModal($id: ID!, $kind: ChangeRequestDependency!) {
  changeRequest(id: $id) {
    ...DependencyModal_ChangeRequest
  }
  availableDependencyChangeRequests(id: $id, kind: $kind) {
    ...DependencyModalOption_ChangeRequest
  }
}
    ${DependencyModal_ChangeRequestFragmentDoc}
${DependencyModalOption_ChangeRequestFragmentDoc}`;

/**
 * __useChangeRequestsDependencyModalQuery__
 *
 * To run a query within a React component, call `useChangeRequestsDependencyModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useChangeRequestsDependencyModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChangeRequestsDependencyModalQuery({
 *   variables: {
 *      id: // value for 'id'
 *      kind: // value for 'kind'
 *   },
 * });
 */
export function useChangeRequestsDependencyModalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ChangeRequestsDependencyModalQuery, ChangeRequestsDependencyModalQueryVariables> & ({ variables: ChangeRequestsDependencyModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChangeRequestsDependencyModalQuery, ChangeRequestsDependencyModalQueryVariables>(ChangeRequestsDependencyModalDocument, options);
      }
export function useChangeRequestsDependencyModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChangeRequestsDependencyModalQuery, ChangeRequestsDependencyModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChangeRequestsDependencyModalQuery, ChangeRequestsDependencyModalQueryVariables>(ChangeRequestsDependencyModalDocument, options);
        }
// @ts-ignore
export function useChangeRequestsDependencyModalSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ChangeRequestsDependencyModalQuery, ChangeRequestsDependencyModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChangeRequestsDependencyModalQuery, ChangeRequestsDependencyModalQueryVariables>;
export function useChangeRequestsDependencyModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChangeRequestsDependencyModalQuery, ChangeRequestsDependencyModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChangeRequestsDependencyModalQuery | undefined, ChangeRequestsDependencyModalQueryVariables>;
export function useChangeRequestsDependencyModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChangeRequestsDependencyModalQuery, ChangeRequestsDependencyModalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ChangeRequestsDependencyModalQuery, ChangeRequestsDependencyModalQueryVariables>(ChangeRequestsDependencyModalDocument, options);
        }
export type ChangeRequestsDependencyModalQueryHookResult = ReturnType<typeof useChangeRequestsDependencyModalQuery>;
export type ChangeRequestsDependencyModalLazyQueryHookResult = ReturnType<typeof useChangeRequestsDependencyModalLazyQuery>;
export type ChangeRequestsDependencyModalSuspenseQueryHookResult = ReturnType<typeof useChangeRequestsDependencyModalSuspenseQuery>;
export type ChangeRequestsDependencyModalQueryResult = ApolloReactCommon.QueryResult<ChangeRequestsDependencyModalQuery, ChangeRequestsDependencyModalQueryVariables>;
export const ChangeRequestGroupsForModalDocument = gql`
    query ChangeRequestGroupsForModal {
  changeRequestGroups {
    ...DependencyModal_ChangeRequestGroup
  }
}
    ${DependencyModal_ChangeRequestGroupFragmentDoc}`;

/**
 * __useChangeRequestGroupsForModalQuery__
 *
 * To run a query within a React component, call `useChangeRequestGroupsForModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useChangeRequestGroupsForModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChangeRequestGroupsForModalQuery({
 *   variables: {
 *   },
 * });
 */
export function useChangeRequestGroupsForModalQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ChangeRequestGroupsForModalQuery, ChangeRequestGroupsForModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChangeRequestGroupsForModalQuery, ChangeRequestGroupsForModalQueryVariables>(ChangeRequestGroupsForModalDocument, options);
      }
export function useChangeRequestGroupsForModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChangeRequestGroupsForModalQuery, ChangeRequestGroupsForModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChangeRequestGroupsForModalQuery, ChangeRequestGroupsForModalQueryVariables>(ChangeRequestGroupsForModalDocument, options);
        }
// @ts-ignore
export function useChangeRequestGroupsForModalSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ChangeRequestGroupsForModalQuery, ChangeRequestGroupsForModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChangeRequestGroupsForModalQuery, ChangeRequestGroupsForModalQueryVariables>;
export function useChangeRequestGroupsForModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChangeRequestGroupsForModalQuery, ChangeRequestGroupsForModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChangeRequestGroupsForModalQuery | undefined, ChangeRequestGroupsForModalQueryVariables>;
export function useChangeRequestGroupsForModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChangeRequestGroupsForModalQuery, ChangeRequestGroupsForModalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ChangeRequestGroupsForModalQuery, ChangeRequestGroupsForModalQueryVariables>(ChangeRequestGroupsForModalDocument, options);
        }
export type ChangeRequestGroupsForModalQueryHookResult = ReturnType<typeof useChangeRequestGroupsForModalQuery>;
export type ChangeRequestGroupsForModalLazyQueryHookResult = ReturnType<typeof useChangeRequestGroupsForModalLazyQuery>;
export type ChangeRequestGroupsForModalSuspenseQueryHookResult = ReturnType<typeof useChangeRequestGroupsForModalSuspenseQuery>;
export type ChangeRequestGroupsForModalQueryResult = ApolloReactCommon.QueryResult<ChangeRequestGroupsForModalQuery, ChangeRequestGroupsForModalQueryVariables>;
export const SaveChangeRequestDependencyBlockingDocument = gql`
    mutation SaveChangeRequestDependencyBlocking($id: ID!, $blocking: [SaveChangeRequestDependencyInput!]) {
  saveChangeRequest(input: {id: $id, blocking: $blocking}) {
    changeRequest {
      ...DependencyModal_ChangeRequest
    }
  }
}
    ${DependencyModal_ChangeRequestFragmentDoc}`;

/**
 * __useSaveChangeRequestDependencyBlockingMutation__
 *
 * To run a mutation, you first call `useSaveChangeRequestDependencyBlockingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveChangeRequestDependencyBlockingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveChangeRequestDependencyBlockingMutation, { data, loading, error }] = useSaveChangeRequestDependencyBlockingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      blocking: // value for 'blocking'
 *   },
 * });
 */
export function useSaveChangeRequestDependencyBlockingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveChangeRequestDependencyBlockingMutation, SaveChangeRequestDependencyBlockingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveChangeRequestDependencyBlockingMutation, SaveChangeRequestDependencyBlockingMutationVariables>(SaveChangeRequestDependencyBlockingDocument, options);
      }
export type SaveChangeRequestDependencyBlockingMutationHookResult = ReturnType<typeof useSaveChangeRequestDependencyBlockingMutation>;
export type SaveChangeRequestDependencyBlockingMutationResult = ApolloReactCommon.MutationResult<SaveChangeRequestDependencyBlockingMutation>;
export const SaveChangeRequestDependencyBlockersDocument = gql`
    mutation SaveChangeRequestDependencyBlockers($id: ID!, $blockers: [SaveChangeRequestDependencyInput!]) {
  saveChangeRequest(input: {id: $id, blockers: $blockers}) {
    changeRequest {
      ...DependencyModal_ChangeRequest
    }
  }
}
    ${DependencyModal_ChangeRequestFragmentDoc}`;

/**
 * __useSaveChangeRequestDependencyBlockersMutation__
 *
 * To run a mutation, you first call `useSaveChangeRequestDependencyBlockersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveChangeRequestDependencyBlockersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveChangeRequestDependencyBlockersMutation, { data, loading, error }] = useSaveChangeRequestDependencyBlockersMutation({
 *   variables: {
 *      id: // value for 'id'
 *      blockers: // value for 'blockers'
 *   },
 * });
 */
export function useSaveChangeRequestDependencyBlockersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveChangeRequestDependencyBlockersMutation, SaveChangeRequestDependencyBlockersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveChangeRequestDependencyBlockersMutation, SaveChangeRequestDependencyBlockersMutationVariables>(SaveChangeRequestDependencyBlockersDocument, options);
      }
export type SaveChangeRequestDependencyBlockersMutationHookResult = ReturnType<typeof useSaveChangeRequestDependencyBlockersMutation>;
export type SaveChangeRequestDependencyBlockersMutationResult = ApolloReactCommon.MutationResult<SaveChangeRequestDependencyBlockersMutation>;
export const SaveChangeRequestRelatedToDocument = gql`
    mutation SaveChangeRequestRelatedTo($id: ID!, $linkedTo: [SaveChangeRequestLinkInput!], $groups: [SaveChangeRequestGroupInput!]!) {
  saveChangeRequest(input: {id: $id, linkedTo: $linkedTo}) {
    changeRequest {
      ...DependencyModal_ChangeRequest
    }
  }
  saveChangeRequestGroups(input: $groups) {
    changeRequestGroups {
      id
      name
      changeRequests {
        ...DependencyModal_ChangeRequest
      }
    }
  }
}
    ${DependencyModal_ChangeRequestFragmentDoc}`;

/**
 * __useSaveChangeRequestRelatedToMutation__
 *
 * To run a mutation, you first call `useSaveChangeRequestRelatedToMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveChangeRequestRelatedToMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveChangeRequestRelatedToMutation, { data, loading, error }] = useSaveChangeRequestRelatedToMutation({
 *   variables: {
 *      id: // value for 'id'
 *      linkedTo: // value for 'linkedTo'
 *      groups: // value for 'groups'
 *   },
 * });
 */
export function useSaveChangeRequestRelatedToMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveChangeRequestRelatedToMutation, SaveChangeRequestRelatedToMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveChangeRequestRelatedToMutation, SaveChangeRequestRelatedToMutationVariables>(SaveChangeRequestRelatedToDocument, options);
      }
export type SaveChangeRequestRelatedToMutationHookResult = ReturnType<typeof useSaveChangeRequestRelatedToMutation>;
export type SaveChangeRequestRelatedToMutationResult = ApolloReactCommon.MutationResult<SaveChangeRequestRelatedToMutation>;